import React from 'react'
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import Dialog from "@mui/material/Dialog";
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";

export default function BatchTable(props) {
    if (!props.isShown) return null;

    const columnDefs = [
        { headerName: 'Batch Number', field: 'BATCHNBR', minWidth: 170 },
        { headerName: 'Material', field: 'MATERIALNUMBER', minWidth: 130 },
        { headerName: 'Material Name', field: 'DESCRIPTION', minWidth: 220 },
        { headerName: 'Quantity', field: 'ACTAULSTK', minWidth: 120 },
        { headerName: 'UOM', field: 'UOM', minWidth: 100 },
        { headerName: 'Status', field: 'STATUS', minWidth: 130 },
        { headerName: 'Last Ship SL', field: 'LASTSHIPSL', minWidth: 130 },
        { headerName: 'Last Ship SL Expiration', field: 'LSSLEXPIRATION', minWidth: 200 },
        { headerName: 'TSL Expiration', field: 'TSLEXPIRATION', minWidth: 150 },
        { headerName: 'Plant', field: 'PLANT', minWidth: 120 },
    ].map((col) => ({
        ...col,
        suppressMenu: true,
        suppressHeaderMenuButton: true,
    }));

    const columnDef = {
        sortable: false,
        filter: false,
        editable: false,
        suppressMenu: true,
        suppressHeaderMenuButton: true,
        menuTabs: [],
        minWidth: 120,
        cellStyle: {
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: 1.5,
            display: "flex",
            alignItems: "center",
            borderRight: "1px solid #ddd",
        },
    }

    return (
        <Dialog open={props.isShown} onClose={props.handleBatchDialogClose} fullWidth maxWidth="sm">
            <Box sx={{ p: 3 }}>
                <Typography variant="h6" sx={{ mb: 3 }}>
                    Batch Information: {props.selectedMaterial}
                </Typography>
                <Box sx={{ mb: 3 }}>
                    {props.loading ? (
                        <Box display="flex" justifyContent="center" alignItems="center" sx={{ height: 100 }}>
                            <CircularProgress size={32} sx={{ color: '#000' }} />
                        </Box>
                    ) : props.materialBatchesData && props.materialBatchesData.length > 0 ? (
                        <div className="ag-theme-quartz" style={{ height: 280, width: "100%" }}>
                            <AgGridReact
                                rowData={props.materialBatchesData}
                                columnDefs={columnDefs}
                                pagination={false}
                                suppressMenuHide={false}
                                defaultColDef={columnDef}
                            />
                        </div>
                    ) : (
                        <Typography>No data available</Typography>
                    )}
                </Box>
                <Box display="flex" justifyContent="flex-end">
                    <Button
                        variant="contained"
                        onClick={props.handleBatchDialogClose}
                        sx={{
                            backgroundColor: "#000",
                            "&:hover": { backgroundColor: "#000" },
                            textTransform: "none",
                            color: "#fff",
                        }}
                    >
                        Close
                    </Button>
                </Box>
            </Box>
        </Dialog>
    )
}
